export { MorphemeInfoPanelDictionaryCompositionSection } from "#morpheme-info-panel-dictionary-composition-section";
